export default __webpack_public_path__ + "static/media/education.00fd39a6.png";